import { createStyles, makeStyles , Theme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';


export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position:"absolute",
      margin:0,
      right:0,
      padding:"0.313rem 0.625rem",
      border:"1px solid #FFDD02",
      background: "rgba(255, 221, 2, 0.15)",
      borderRadius: "3.5rem",
      fontStyle:"normal",
      fontSize:"0.938rem",
      lineHeight:"1.25rem",
      fontWeight:400
    }
  }))

export  function OrderOnlyStatus() {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <p className={classes.root}>{t('orderHistory.modal.OrderOnlyStatus')}</p>
  )
}
